<template>
    <main-content with_go_back_bar>
        <kt-panel v-if="dedicatedListStatus === 'success' && findCatStatus === 'success' && arrange_priority_status">
            <kt-panel-body>
                <form class="kt-form" @submit.prevent="update" >
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col lg="6" md="6" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="cat_name">
                                        {{ $t('label.cat_name') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="rtl"
                                        type="cat_name"
                                        name="cat_name"
                                        id="cat_name"
                                        v-model="categoryData.title"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-for="priority in 3" :key="priority" lg="6" md="6" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="dedicated_shop_id_first_priority">
                                        {{ $t('label.gateway') + ' (' + $t('transaction_routing.priority.'+priority) + ')' }}
                                    </kt-form-label>
                                    <select
                                        :id="'dedicated_shop_id_'+priority-1"
                                        class="form-control kt-selectpicker"
                                        v-model="categoryData.dedicated_ids[(priority-1)]"
                                    >
                                        <option value=""></option>
                                        <option
                                            v-bind:key="index"
                                            v-for="(category, index) in gateways"
                                            :value="category.id"
                                            :selected="categoryData.dedicated_ids[(priority-1)] == category.id"
                                        >
                                            {{ category.farsi_name }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>

                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {dedicatedService, userService} from "@/common/api.service";
import Vue from "vue";
import {KTUtil} from "@/plugins/core/util";
import {mapGetters} from "vuex";
import {i18n} from "@/plugins/i18n";

export default {
    components: {
        MainContent
    },
    data() {
        return {
            query: {},
            arrange_priority_status : false,
            priorities : {}
        }
    },
    mounted() {
        this.$store.commit('dedicated/failForCategories')
        this.afterMounted()
    },
    computed: {
        ...mapGetters('dedicated', [
            'categoryData',
            'dedicatedListStatus',
            'findCatStatus',
            'gateways',
        ])
    },
    methods: {
        afterMounted() {
            if (this.dedicatedListStatus !== 'success') {
                this.$store.dispatch('dedicated/fetchForSelect').finally(() => {
                    this.$store.dispatch('dedicated/fetchCategory', this.$route.params.hashid).finally(() => {
                        this.runArrangePriorities()
                    })
                })
            } else {
                this.$store.dispatch('dedicated/fetchCategory', this.$route.params.hashid).finally(() => {
                    this.runArrangePriorities()
                })
            }
        },
        runSelectPicker() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 500)
        },
        update(e) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    title : {
                        required: true,
                    }
                },
            });

            if(!form.valid()) {
                return
            }
            const priorities = this.categoryData.dedicated_ids;

            let highestFilledPriority = -1;

            for (let i = priorities.length - 1; i >= 0; i--) {
                if (priorities[i] && priorities[i] !== '') {
                    highestFilledPriority = i;
                    break;
                }
            }

            if (highestFilledPriority !== -1) {
                for (let i = 0; i < highestFilledPriority; i++) {
                    if (!priorities[i] || priorities[i] === '') {
                        return this.showMsg(form, 'danger', i18n.t('transaction_routing.cat_dedicated_shop_id_by_priority_alert'));
                    }
                }
            }
            let cleaned_dedicated_ids = this.categoryData.dedicated_ids.filter(value => value !== null && value !== '');
            let unique_dedicated_ids = cleaned_dedicated_ids.filter((e, i, self) => i === self.indexOf(e));
            if (cleaned_dedicated_ids.length !== unique_dedicated_ids.length) {
                return this.showMsg(form, 'danger', i18n.t('transaction_routing.cat_dedicated_shop_id_repeated_alert'));
            }
            let params = {
                title: this.categoryData.title,
                dedicated_ids: cleaned_dedicated_ids,
            }

            KTApp.progress(btn)
            dedicatedService.updateCategory(params, this.$route.params.hashid)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        runArrangePriorities() {
            this.arrange_priority_status = true;
            this.runSelectPicker();
        }
    }
}
</script>